export const FETCH_ALL_FUNCTIONS_REQUEST = "FETCH_ALL_FUNCTIONS_REQUEST";
export const FETCH_ALL_FUNCTIONS_SUCCESS = "FETCH_ALL_FUNCTIONS_SUCCESS";
export const FETCH_ALL_FUNCTIONS_ERROR = "FETCH_ALL_FUNCTIONS_ERROR";

export const FETCH_FUNCTION_BY_ID_REQUEST = "FETCH_FUNCTION_BY_ID_REQUEST";
export const FETCH_FUNCTION_BY_ID_SUCCESS = "FETCH_FUNCTION_BY_ID_SUCCESS";
export const FETCH_FUNCTION_BY_ID_ERROR = "FETCH_FUNCTION_BY_ID_ERROR";

export const FETCH_FUNCTIONS_FOR_TEMPLATE_ID_REQUEST =
  "FETCH_FUNCTIONS_FOR_TEMPLATE_ID_REQUEST";
export const FETCH_FUNCTIONS_FOR_TEMPLATE_ID_SUCCESS =
  "FETCH_FUNCTIONS_FOR_TEMPLATE_ID_SUCCESS";
export const FETCH_FUNCTIONS_FOR_TEMPLATE_ID_ERROR =
  "FETCH_FUNCTIONS_FOR_TEMPLATE_ID_ERROR";

export const MASS_RUN_FUNCTION_REQUEST = "MASS_RUN_FUNCTION_REQUEST";
export const MASS_RUN_FUNCTION_SUCCESS = "MASS_RUN_FUNCTION_SUCCESS";
export const MASS_RUN_FUNCTION_ERROR = "MASS_RUN_FUNCTION_ERROR";

export const RUN_FUNCTION_REQUEST = "RUN_FUNCTION_REQUEST";
export const RUN_FUNCTION_SUCCESS = "RUN_FUNCTION_SUCCESS";
export const RUN_FUNCTION_ERROR = "RUN_FUNCTION_ERROR";
